<template lang="pug">
  div
    .mb-2.d-flex.justify-content-center
      img(src="/img/bookli-logo.svg" width="250px")

    p.text-muted {{ $t('components.shared.appWelcomeFlow.welcome.title') }}

    div.mb-3.d-flex.justify-content-center
      img.partner-logo.mr-3(src="/img/padelclub.png")
      img.partner-logo(src="/img/padelpadel-logo.png")

    p.text-muted {{ $t('components.shared.appWelcomeFlow.welcome.text') }}

    p.text-body {{ $t('components.shared.appWelcomeFlow.welcome.final') }}

    b-button.mt-4(
      block
      @click="$emit('nextStep')"
      size="lg"
      variant="primary") {{ $t('components.shared.appWelcomeFlow.welcome.next') }}

</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { } from '@/graphql';

@Component({
  components: {

  },
  apollo: {

  }
})
export default class CompanyUsersUserView extends Vue {

}
</script>

<style lang="sass" scoped>


.partner-logo
  width: auto
  height: 80px

</style>